var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight2 = function SvgArrowRight2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M3.952 2.449a.675.675 0 0 1 .955 0L7.75 5.292a1 1 0 0 1 0 1.414L4.906 9.551a.675.675 0 0 1-.955-.954l2.597-2.598-2.596-2.596a.675.675 0 0 1 0-.954",
    clipRule: "evenodd"
  })));
};
export { SvgArrowRight2 as ReactComponent };